/** Hindi: the model on this phone: Settings › On-device model, and the chat's one offer and lines about it. */
export const model = {
    "model.title": "आपके एजेंट का मॉडल",
    "model.check": "फिर से जाँचें",
    "model.checking": "इस फ़ोन की जाँच हो रही है…",
    "model.none": "इस फ़ोन पर कोई मॉडल नहीं है।",
    "model.ready": "तैयार",
    "model.not_ready": "तैयार नहीं",
    "model.free_mb": "{mb} एमबी ख़ाली",
    "model.auto": "अपने-आप",
    "model.auto_about": "GigSync का अपना मॉडल, भारत में GigSync के कंप्यूटर पर, आपकी बात समझने के लिए आपका लिखा पढ़ता है; उसे रखा नहीं जाता। वह न मिले, तो फ़ोन का मॉडल तैयार हो तो वह; नहीं तो लाइट मोड।",
    "model.device": "फ़ोन पर",
    "model.device_about": "हमेशा फ़ोन का अपना मॉडल। जवाब न दे पाए तभी लाइट मोड।",
    "model.lite": "लाइट मोड",
    "model.lite_about": "कोई मॉडल नहीं। नियम और तय ढाँचे हर काम करते हैं: सौदा, रिकॉर्ड, भुगतान।",
    "model.ollama": "Ollama (डेव)",
    "model.ollama_about": "सिर्फ़ डेवलपमेंट बिल्ड: इस कंप्यूटर पर `ollama serve` से चलता मॉडल।",
    "model.ollama_model": "Ollama मॉडल",
    "model.ollama_choose": "Ollama में मौजूद मॉडल चुनें",
    "model.ollama_name": "Ollama मॉडल का नाम",
    "model.ollama_off": "Ollama नहीं चल रहा: `ollama serve` चलाएँ, या नाम लिखें",
    "model.ollama_looking": "Ollama खोज रहे हैं…",
    "model.use": "यह मॉडल इस्तेमाल करें",
    "model.now": "अभी जवाब दे रहा है: {model}",
    "model.still_works": "लाइट मोड में भी सब कुछ चलता है; मॉडल सिर्फ़ शब्दों में मदद करता है।",
    "model.lite_label": "लाइट मोड (कोई मॉडल नहीं)",
    "model.ollama_label": "Ollama: {name} (डेव)",
    "model.not_ready_lite": "{device} · तैयार नहीं, इसलिए लाइट मोड",
    "model.on_device_label": "फ़ोन पर: {engine}",
    "model.auto_label": "अपने-आप · {model}",
    "model.server_label": "GigSync का मॉडल",
    "model.offer": "आपका एजेंट आपकी बात बेहतर समझे: इस फ़ोन पर लगभग {mb} एमबी डाउनलोड करें।",
    "model.offer_download": "डाउनलोड करें",
    "model.offer_later": "बाद में",
    "model.mobile_data": "आप मोबाइल डेटा पर हैं: इसमें लगभग {mb} एमबी डेटा लगेगा।",
    "model.wifi_best": "वाई-फ़ाई पर करना बेहतर है।",
    "model.private": "यह सिर्फ़ इसी फ़ोन पर चलता है: आप जो लिखते हैं, वह फ़ोन से बाहर नहीं जाता।",
    "model.downloading": "मॉडल इस फ़ोन पर डाउनलोड हो रहा है: {percent}% ({mb} में से {done} एमबी)",
    "model.paused": "मॉडल का डाउनलोड बीच में रुक गया। जहाँ रुका था, वहीं से आगे चलेगा।",
    "model.resume": "डाउनलोड आगे बढ़ाएँ",
    "model.ready_line": "आपका एजेंट अब इसी फ़ोन पर चलता है, बिना इंटरनेट के भी",
    "model.state_ready": "तैयार",
    "model.state_downloadable": "डाउनलोड नहीं हुआ",
    "model.state_downloading": "डाउनलोड हो रहा है {percent}%",
    "model.line": "{name} · लगभग {mb} एमबी · {state}",
    "model.download": "डाउनलोड करें (लगभग {mb} एमबी)",
    "model.remove": "इस फ़ोन से हटाएँ",
    "model.why.no_webgpu": "यह ब्राउज़र इस फ़ोन पर मॉडल नहीं चला सकता (WebGPU नहीं है)। लाइट मोड हर काम करता है।",
    "model.why.gpu_limits": "इस फ़ोन का ग्राफ़िक्स चिप मॉडल के लिए छोटा है। लाइट मोड हर काम करता है।",
    "model.why.low_memory": "इस फ़ोन में मॉडल के लिए मेमोरी कम है। लाइट मोड हर काम करता है।",
    "model.why.unknown_memory": "यह ब्राउज़र नहीं बताता कि इस फ़ोन में कितनी मेमोरी है, इसलिए मॉडल नहीं दिया जाता। समझने का पैक यह काम करता है।",
    "model.why.low_storage": 'मॉडल के लिए जगह कम है। कुछ जगह ख़ाली करें, फिर "फिर से जाँचें" दबाएँ।',
    "model.why.browser": "यह ब्राउज़र मॉडल नहीं रख सकता। नया क्रोम या सफ़ारी इस्तेमाल करें।",
};
//# sourceMappingURL=model.js.map